import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { WeldPartDetail, WeldPartDetailProps } from './welding-part-detail';

export interface WeldPartDetailModalProps extends WeldPartDetailProps {
  isOpen?: boolean;
  onDismiss: () => void;
  presentingEl?: HTMLElement;
}

const WeldPartDetailModal = (props: WeldPartDetailModalProps) => {
  const { presentingEl, isOpen, onDismiss } = props;

  const { i18n } = useTranslation();

  return (
    <IonModal
      presentingElement={presentingEl}
      isOpen={isOpen}
      canDismiss={true}
      onDidDismiss={onDismiss}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonButton onClick={onDismiss}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{i18n.t('welding:part_details')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <WeldPartDetail
        afterSave={() => {
          onDismiss();
        }}
      />
    </IonModal>
  );
};

export { WeldPartDetailModal };
